import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../views/jumprope-offline-match/Index.vue')
const Login = () => import('../views/jumprope-offline-match/login/Login.vue')
const Test = () => import('../views/jumprope-offline-match/test.vue')
const TestBc = () => import('../views/jumprope-offline-match/test-bc.vue')
const TestRace50 = () => import('../views/jumprope-offline-match/test-race50.vue')
const CompetitionList = () => import('../views/jumprope-offline-match/CompetitionList.vue')
const Selection = () => import('../views/jumprope-offline-match/Selection.vue')
const CheckinList = () => import('../views/jumprope-offline-match/CheckinList.vue')
const CheckinFlow = () => import('../views/jumprope-offline-match/CheckinFlow.vue')
const BindList = () => import('../views/jumprope-offline-match/BindList.vue')
const BindFlow = () => import('../views/jumprope-offline-match/BindFlow.vue')
const Race = () => import('../views/jumprope-offline-match/Race.vue')

export const loginRoute: RouteConfig = {
  path: 'login',
  name: 'jumprope_offline_match_login',
  component: Login,
  meta: { title: '登录', ignoreLogin: true },
}

export const faceCaptureTestRoute: RouteConfig = {
  path: '/jumprope-offline-match/test',
  name: 'jumprope_offline_match_face_capture_test',
  component: Test,
  meta: { title: 'Bridge 测试', ignoreLogin: true },
}

export const bcProtocolTestRoute: RouteConfig = {
  path: '/jumprope-offline-match/test-bc',
  name: 'jumprope_offline_match_bc_protocol_test',
  component: TestBc,
  meta: { title: 'BC 协议测试', ignoreLogin: true },
}

export const race50TestRoute: RouteConfig = {
  path: '/jumprope-offline-match/test-race50',
  name: 'jumprope_offline_match_test_race50',
  component: TestRace50,
  meta: { title: 'Race50 BC 跳绳', ignoreLogin: true },
}

export const offlineMatchIndexRoute: RouteConfig = {
  path: '/jumprope-offline-match',
  component: Index,
  redirect: '/jumprope-offline-match/competitions',
  meta: {
    title: '赛事检录',
  },
  children: [
    loginRoute,
    {
      path: 'competitions',
      name: 'jumprope_offline_match_competitions',
      component: CompetitionList,
      meta: {
        title: '赛事列表',
      },
    },
    {
      path: 'selection',
      name: 'jumprope_offline_match_selection',
      component: Selection,
      props: (route) => ({ ...route.query }),
      meta: {
        title: '选择场次',
      },
    },
    {
      path: 'checkin',
      name: 'jumprope_offline_match_checkin',
      component: CheckinList,
      props: (route) => ({ ...route.query }),
      meta: {
        title: '预检',
      },
    },
    {
      path: 'checkin/flow',
      name: 'jumprope_offline_match_checkin_flow',
      component: CheckinFlow,
      props: (route) => ({ ...route.query }),
      meta: {
        title: '预检',
      },
    },
    {
      path: 'bind',
      name: 'jumprope_offline_match_bind',
      component: BindList,
      props: (route) => ({ ...route.query }),
      meta: {
        title: '绑定跳绳',
      },
    },
    {
      path: 'bind/flow',
      name: 'jumprope_offline_match_bind_flow',
      component: BindFlow,
      props: (route) => ({ ...route.query }),
      meta: {
        title: '绑定跳绳',
      },
    },
    {
      path: 'race',
      name: 'jumprope_offline_match_race',
      component: Race,
      props: (route) => ({ ...route.query }),
      meta: {
        title: '比赛',
      },
    },
  ],
}

export default [offlineMatchIndexRoute, faceCaptureTestRoute, bcProtocolTestRoute, race50TestRoute]

export function navigateToJumpropeOfflineMatchLogin(router: VueRouter) {
  router.push({ name: loginRoute.name })
}

export function navigateToJumpropeOfflineMatchCompetitions(router: VueRouter) {
  router.push({ name: 'jumprope_offline_match_competitions' })
}
